import { render, staticRenderFns } from "./ProjectsPanel.vue?vue&type=template&id=69e9a96a&scoped=true&"
import script from "./ProjectsPanel.vue?vue&type=script&lang=js&"
export * from "./ProjectsPanel.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsPanel.vue?vue&type=style&index=0&id=69e9a96a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e9a96a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
